module.exports = __webpack_public_path__ + "img/icon_section_klimat.5bab743d.svg";